// extracted by mini-css-extract-plugin
export default {"headerButtons":"PipelineDetails_headerButtons__JYL8a","title":"PipelineDetails_title__kvold","detailsWrapper":"PipelineDetails_detailsWrapper__KHo4Q"};